import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { InstitutionData } from '../Models/InstitutionData';
import { PHBHPFeaturePackageInsitutionManagementService } from '../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserData } from '../Models/UserData';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common'
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-manageinstitution',
  templateUrl: './ph-bhp-manageinstitution.component.html',
  styleUrls: ['./ph-bhp-manageinstitution.component.css']
})
export class PhBhpManageinstitutionComponent implements OnInit, OnDestroy  {

  modalRef: BsModalRef;
  userData: UserData;
  dept= "dep";
  userSubscription: Subscription;
  langSubscription: Subscription;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('ungroupmodal') ungroupmodal: TemplateRef<any>;
  @ViewChild('excelexport') excelexport;
  gridData: InstitutionData[];
  countriesKeyValue: any;
  groupList: InstitutionData[];
  imgItems: boolean = true;
  itemChange: boolean = false;
  addToGroup = {} as InstitutionData;
  removeFromGroup = {} as InstitutionData;
  searchText: string;
  searchTextGroup: string;
  deleteDataItem;
  groupDataItem;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  fields: any[] = [
    // {
    //   'field': 'image', 'title': '', 'width': 50, "ngTemplate": (dataItem) => {
    //     return  `<img src="assets/ph-bhp-institution/svg/Clean Hands.svg">`;
    //   }
    // },
    {
      'field': 'countryName', 'title': 'INSTITUTION_MANAGEMENT.COUNTRY',
      // 'ngTemplate': (dataItem) => {
      //   const countryName = dataItem.institution.countryName;
      //   return this.layoutService.translateText(countryName);
      // }
    },
    {
      'field': 'groupName', 'title': 'INSTITUTION_MANAGEMENT.GROUP_2',
    },
    {
      'field': 'institutionName', 'title': 'INSTITUTION_MANAGEMENT.INSTITUTIONS',
    },
    { 'field': 'bedSize', 'title': 'INSTITUTION_MANAGEMENT.HASH_BEDS' },
    {
      'field': 'userAccounts', 'title': this.translationKeys.InstitutionManagement.Accounts,
      // 'ngTemplate': (dataItem) => {
      //   let canShowActionItem = true;;
      //   if (this.userData.roleName.roleId == 3 || this.userData.roleName.roleId == 4) {
      //     canShowActionItem = false;
      //   }
      //   if (dataItem.institution.groupName != '') {
      //     canShowActionItem = false;
      //   }
      //   if (dataItem.institution.institution.isGroup) {
      //     canShowActionItem = false;
      //   }
      //   let actionItems = JSON.parse(JSON.stringify(this.actionItems));
      //   if (!canShowActionItem) {
      //     let removableIndex = actionItems.findIndex(el => el.name == "INSTITUTION_MANAGEMENT.ADD_TO_GROUP");
      //     actionItems.splice(removableIndex, 1);
      //   }
      //   let filtered = [];
      //   for (var arr in this.actionItems) {
      //     for (var filter in actionItems) {
      //       if (this.actionItems[arr].name == actionItems[filter].name) {
      //         filtered.push(this.actionItems[arr]);
      //       }
      //     }
      //   }
      //   dataItem.actionItems = filtered;
      //   if (!dataItem.institution.institution.isGroup) {
      //     if (dataItem.institution.institution.usedLicenseCount === null) {
      //       dataItem.institution.institution.usedLicenseCount = 0;
      //     }
      //   }
      //   return (dataItem.institution.institution.isGroup) ? "" : (dataItem.institution.institution.usedLicenseCount + "/" +dataItem.institution.institution.userLicense);
      // }
    },
    {
      'field': 'institutionType', 'title': 'INSTITUTION_MANAGEMENT.TYPE'
    },
    {'field' : 'activateWebKess', 'title': 'webKess',
    // 'ngTemplate': (dataItem) => {
    //   // return (dataItem.institution.institution.activateWebKess == true) ? this.data.translatetext('Enabled') :  ''
    //   return (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.additionalChanges)  ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.layoutService.translateText('DASHBOARD.OBSERVATIONS')+'-'+this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.layoutService.translateText('DASHBOARD.OBSERVATIONS') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
    //  }
    },
  ];


  actionItems: any = [
    {
      name: 'INSTITUTION_MANAGEMENT.VIEW', imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg', onClick: (dataItem) => {
        this.onChildData('/institution/view/' + dataItem.institution.institution.institutionID)
      }
    },
    { name: 'INSTITUTION_MANAGEMENT.EDIT_2', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', onClick: (dataItem) => { this.onChildData('/institution/edit/' + dataItem.institution.institution.institutionID) } },
    { name: 'INSTITUTION_MANAGEMENT.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) } },
    {
      name: 'INSTITUTION_MANAGEMENT.ADD_USER', imgSrc: 'assets/img/svg/icon-add-user-blue.svg',
      canShow: (dataItem) => { return !(this.userData.roleName.roleId == 3 && dataItem.institution.institution.isGroup) },
      onClick: (dataItem) => {
        this.onChildData(`user/addInstitution/${dataItem.institution.institution.institutionID}/${(dataItem.institution.institution.isGroup) ? 1 : 0}`);        
      }
    },
    {
      name: 'webKess', imgSrc: 'assets/img/menuActive/icon-chc-blue.svg',
      canDisable: (dataItem) => {
        return ((dataItem.institution.countryName !== 'Germany') &&
            (dataItem.institution.countryName !== 'Switzerland') &&
            (dataItem.institution.countryName !== 'Austria'));
      },
      onClick: (dataItem) => {
        // tslint:disable-next-line: max-line-length
        this.onChildData(`/institution/webKess/${dataItem.institution.institution.institutionID}/${dataItem.institution.institution.packageID}`);
      }
    },
    {
      name: 'INSTITUTION_MANAGEMENT.ADD_TO_GROUP',
      imgSrc: 'assets/img/svg/add-to-group.svg',
      canShow: (dataItem) => { return this.showGroupButton(dataItem) },
      onClick: (dataItem) => {
        if (!dataItem.institution.institution.isGroup) {
          this.openModal(this.template, dataItem);
        }
      }
    },
    {
      name: 'INSTITUTION_MANAGEMENT.REMOVE_FROM_GROUP',
      imgSrc: 'assets/img/svg/remove-from-group.svg',
      canShow: (dataItem) => { return this.showUnGroupButton(dataItem) },
      onClick: (dataItem) => {
        if (!dataItem.institution.institution.isGroup) {
          this.openUnGroupModal(this.ungroupmodal, dataItem);
        }
      }
    },
    { name: 'INSTITUTION_MANAGEMENT.ADD_CONSUMPTION', imgSrc: 'assets/img/svg/icon-add-consumption.svg',
      onClick: (dataItem) => { this.onChildData('/consumption/add'); }
    }
  ];

  pageInfo = {
    items: 'INSTITUTION_MANAGEMENT.INSTITUTIONS',
    itemsPerPageLabel: 'INSTITUTION_MANAGEMENT.INSTITUTIONS_PER_PAGE'
  };
  dataForExcel: Object[];
  fieldsExcel: string[];
  errFromExport: boolean = false;
  emptyArrayExport: boolean = false;
  copiedRes: Array<Object>;
  langChanged: boolean;
  currentLang: string;
  noWebKessInsPresent: boolean;


  constructor(
    private router: Router,
    public config: AppConfig,
    private modalService: BsModalService,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    public layoutService: PHBHPLayoutPackageService,
    public datepipe: DatePipe
    ) { }

  ngOnInit() {
    this.currentLang = localStorage.getItem('selectedlanguage');
    this.service.getCountriesKeyValuePair().subscribe((res: any) => {
      this.countriesKeyValue = res;
    });

    if(this.config.userData) {
      this.userData = this.config.userData;
      if(this.userData.roleName.roleId == 1 || this.userData.roleName.roleId == 2) {
        this.fetchWebKessForExport();
      }
      this.OnUserChanges();

    }

    this.userSubscription  = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.OnUserChanges();
    })

    this.langSubscription = this.layoutService.lang.asObservable().subscribe((res:any) => {
      this.currentLang = res;
      this.langChanged = true;
      if (this.router.url.includes('institution') &&
        (this.userData.roleName.roleId == 1 || this.userData.roleName.roleId == 2)) {
        this.layoutService.showLoader = true;
        this.fetchWebKessForExport();
      }

      // this.getGridData();
    });
  }

  ngOnDestroy(){
    if(this.userSubscription)
      this.userSubscription.unsubscribe();
    if(this.langSubscription)
      this.langSubscription.unsubscribe();
  }

  escapeRegExp(string){
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  replaceAll(str, term, replacement) {
    return str.replace(new RegExp(this.escapeRegExp(term), 'g'), replacement);
  }


  fetchWebKessForExport() {

    this.service.GetWebKessInstitutions(this.userData.userId, this.userData.roleName.roleId,this.userData.country).subscribe(
      (res:any) => {
        if (this.langChanged) {
          this.layoutService.showLoader = false;
        }
        if (res.length > 0) {
          this.emptyArrayExport = false;
          this.errFromExport = false;

          this.copiedRes  = Array.from(res);
          for(let i = 0, ln = this.copiedRes.length; i < ln; i++ ) {
              let countryId = this.copiedRes[i]['countryID'];
            if (this.copiedRes[i]['soPsName']) {
              if (this.copiedRes[i]['soPsName'].length > 0) {
                this.copiedRes[i]['soPsName'] = this.copiedRes[i]['soPsName'].join(",");
              } else {
                this.copiedRes[i]['soPsName'] = "";
              }
            } else {
              this.copiedRes[i]['soPsName'] = "";
            }
            this.copiedRes[i]['countryID'] = this.read_prop(this.countriesKeyValue, countryId);
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'countryID', this.getKeyTranslation('Country'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'state', this.getKeyTranslation('State'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'groupName', this.getKeyTranslation('Group'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'zipCode', this.getKeyTranslation('Postal code'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'city', this.getKeyTranslation('City'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'addressLine1', this.getKeyTranslation('Street'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'addressLine2', this.getKeyTranslation('Building'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'institutionName', this.getKeyTranslation('Institution'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'createdDateTime', this.getKeyTranslation('Institution-Date'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'bedSize', this.getKeyTranslation('Bed size'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'crmNumber', this.getKeyTranslation('CRM'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'phone', this.getKeyTranslation('Phone'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'fax', this.getKeyTranslation('Fax'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'app', this.getKeyTranslation('App'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'appDate', this.getKeyTranslation('App-Date'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'userAccounts', this.getKeyTranslation('Accounts'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'soPsName', this.getKeyTranslation('Selected SOPs'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'benchmark', this.getKeyTranslation('Benchmark'));
            this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'updatedOnWebKess', this.getKeyTranslation('webKess-Date'));
            // this.copiedRes[i]['isObserveBenchmark'] = (this.copiedRes[i]['isObserveBenchmark'] == true) ? 'active' : (this.copiedRes[i]['isObserveBenchmark'] == null) ? '' : 'inactive';
            // this.copiedRes[i]['isObserveSOPBenchmark'] = (this.copiedRes[i]['isObserveSOPBenchmark'] == true) ? 'active' : (this.copiedRes[i]['isObserveSOPBenchmark'] == null) ? '' : 'inactive';
            // this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'isObserveBenchmark', 'Observe Benchmark');
            // this.copiedRes[i] = this.renameKey(this.copiedRes[i], 'isObserveSOPBenchmark', 'SOP Benchmark');


            let unnecessaryProps = ['activateAutomaticConsumption', 'activateConsumption', 'activateObservation',
              'activateWebKess', 'additionalChanges', 'createdBy', 'groupID', 'institutionID', 'isDeleted',
              'isGroup', 'isObserveBenchmark', 'isObserveSOPBenchmark', 'institutionType', 'listofSOPID', 'packageID', 'productPackage',
              'status', 'trialEndDate', 'typeExpiryDue', 'typeStartDate', 'updatedBy',
              'updatedByWebKess', 'updatedDateTime', 'webKessDate', 'usedLicenseCount', 'stateID', 'pricingComment'];

              for(let j = 0, lng = unnecessaryProps.length; j < lng; j++) {
                Reflect.deleteProperty(this.copiedRes[i], unnecessaryProps[j]);
              }

              this.copiedRes[i] = JSON.parse(JSON.stringify( this.copiedRes[i], [
                this.getKeyTranslation("Country"),
                this.getKeyTranslation("State"),
                this.getKeyTranslation("Postal code"),
                this.getKeyTranslation("City"),
                this.getKeyTranslation("Street"),
                this.getKeyTranslation("Group"),
                this.getKeyTranslation("Institution"),
                this.getKeyTranslation("Institution-Date"),
                this.getKeyTranslation("Building"),
                this.getKeyTranslation("Bed size"),
                this.getKeyTranslation("CRM"),
                this.getKeyTranslation("Phone"),
                this.getKeyTranslation("Fax"),
                this.getKeyTranslation("App"),
                this.getKeyTranslation("App-Date"),
                this.getKeyTranslation("Accounts"),
                this.getKeyTranslation("Benchmark"),
                this.getKeyTranslation("Selected SOPs"),
                "webKess",
                this.getKeyTranslation("webKess-Date")] , 20));

              this.copiedRes[i][this.getKeyTranslation('Country')] = this.layoutService.translateText(this.copiedRes[i][this.getKeyTranslation('Country')]);
              if (this.copiedRes[i][this.getKeyTranslation('State')]) {
                this.copiedRes[i][this.getKeyTranslation('State')] = this.layoutService.translateText(this.copiedRes[i][this.getKeyTranslation('State')]);
              }

              this.copiedRes[i][this.getKeyTranslation('Benchmark')] = this.replaceAll(this.copiedRes[i][this.getKeyTranslation('Benchmark')], 'Active', this.layoutService.translateText('Active'));
              this.copiedRes[i][this.getKeyTranslation('Benchmark')] = this.replaceAll(this.copiedRes[i][this.getKeyTranslation('Benchmark')], 'Inactive', this.layoutService.translateText('Inactive'));


              if(this.userData.roleName.roleId == 2) {
                Reflect.deleteProperty(this.copiedRes[i], this.getKeyTranslation('Country'));
              }

              // SOP translation starts
              if (this.copiedRes[i][this.getKeyTranslation('Selected SOPs')]!=="") {
                let selectedSOPs = this.copiedRes[i][this.getKeyTranslation('Selected SOPs')];
                let selectedSOPs_arr = selectedSOPs.split(',');
                if (selectedSOPs_arr.length > 0) {
                  for (let p = 0, pLength = selectedSOPs_arr.length; p<pLength; p++ ) {
                    selectedSOPs_arr[p] = this.layoutService.translateText(selectedSOPs_arr[p]);
                  }
                  let new_string = selectedSOPs_arr.join(',');
                  this.copiedRes[i][this.getKeyTranslation('Selected SOPs')] = new_string;
                }
              }
              // SOP translation ends

              let dates = [this.getKeyTranslation('Institution-Date'), this.getKeyTranslation('webKess-Date'), this.getKeyTranslation('App-Date')];

            for (let k = 0, lngth = dates.length; k < lngth; k++) {
              if (this.copiedRes[i][dates[k]] !== "" && this.copiedRes[i][dates[k]] !== null) {
                if (this.currentLang == 'de') {
                  this.copiedRes[i][dates[k]] = this.datepipe.transform(this.copiedRes[i][dates[k]], 'dd.MM.yyyy');
                } else {
                  this.copiedRes[i][dates[k]] = this.datepipe.transform(this.copiedRes[i][dates[k]], 'dd/MM/yyyy');
                }
              }
            }

            if(this.userData.roleName.roleId == 1) {
              Reflect.deleteProperty(this.copiedRes[i], 'webKess');
              Reflect.deleteProperty(this.copiedRes[i], this.getKeyTranslation('webKess-Date'));
            }


          }

        } else if (res.length == 0) {
          this.emptyArrayExport = true;
        }
      },
      (err) => {
        this.errFromExport = true;
      },
      () => {

        this.dataForExcel =  this.copiedRes;
        if(this.dataForExcel) {
          this.fieldsExcel = Object.keys(this.dataForExcel[0]);
        }
      }
    )
  }

  getKeyTranslation(key)
  {
    var returnValue ='';
    switch(key)
    {
        case 'Country': returnValue =  this.layoutService.translateText('AUTHORIZATION.COUNTRY'); break;
        case 'State':returnValue = this.layoutService.translateText('AUTHORIZATION.STATE');break;
        case 'Group':returnValue = this.layoutService.translateText('INSTITUTION_MANAGEMENT.GROUP_1');break;
        case 'Postal code':returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.POSTAL_CODE');break;
        case 'City':returnValue = this.layoutService.translateText('AUTHORIZATION.CITY');break;
        case 'Street':returnValue = this.layoutService.translateText('INSTITUTION_MANAGEMENT.STREET');break;
        case 'Building':returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.BUILDING');break;
        case 'Institution':returnValue = this.layoutService.translateText('EVALUATION.INSTITUTION');break;
        case 'Institution-Date': returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.INSTITUTION_DATE');break;
        case 'Bed size': returnValue = this.layoutService.translateText('INSTITUTION_MANAGEMENT.BED_SIZE');break;
        case 'CRM': returnValue = 'CRM';break;
        case 'Phone': returnValue = this.layoutService.translateText('AUTHORIZATION.PHONE');break;
        case 'Fax': returnValue = this.layoutService.translateText('AUTHORIZATION.FAX');break;
        case 'App': returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.APP');break;
        case 'App-Date': returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.APP_DATE');break;
        case 'Licenses': returnValue = this.layoutService.translateText('USER_MANAGEMENT.LICENSES');break;
        case 'Accounts': returnValue = this.layoutService.translateText('USER_MANAGEMENT.ACCOUNTS');break;
        case 'Selected SOPs': returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.SELECTED_SOPS');break;
        case 'Benchmark': returnValue = this.layoutService.translateText('EVALUATION.BENCHMARK');break;
        case 'webKess-Date': returnValue = this.layoutService.translateText('WEBKESS_INTEGRATION.WEBKESS.DATE');break;
    }
    return returnValue;
  }

  delete() {
    this.service.deleteInstitutionById(this.deleteDataItem.institution.institution.institutionID).subscribe(((res: InstitutionData) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = [];
      var index = data.findIndex(institution => institution.institution.institution.institutionID === this.deleteDataItem.institution.institution.institutionID);
      data.splice(index, 1);
      const that = this;
      this.gridData = data.map(item => this.manageGrid(item, that));;
    }));
  }

  OnUserChanges() {
    if (this.userData && this.userData.roleName && !this.itemChange) {
      this.itemChange = true;
      this.getGridData();
      /*
        1) Super Admin
        2) Country Admin
        3) Group Admin
        4) Institution Admin
      */
     if (this.userData.roleName.roleId == 2) {
        if(this.userData.country!="3" && this.userData.country!="219" && this.userData.country!="15") {
          this.fields.splice(this.fields.findIndex(el => el.title == "webKess"), 1);
        }
      }
      if (this.userData && this.userData.roleName) {
        if (this.userData.roleName.roleId !== 1) {
          this.fields.splice(0, 1);
        }
      }
      if (this.userData.roleName.roleId == 1) {
        this.service.GetAllGroups().subscribe((res: [InstitutionData]) => {
          this.groupList = res;
          this.actionItems.splice(7, 1);
        })
      } else if (this.userData.roleName.roleId == 2) {
        this.service.GetGroupsByCountryId(this.userData.country).subscribe((res: [InstitutionData]) => {
          this.groupList = res;
          this.actionItems.splice(7, 1);
        })
      } else if (this.userData.roleName.roleId == 3) {
        this.actionItems.splice(1, 1);
        this.actionItems.splice(5, 2);
        this.actionItems.splice(1, 1);
      } else if (this.userData.roleName.roleId == 4) {
        this.actionItems.splice(1, 1);
        this.actionItems.splice(5, 2);
        this.actionItems.splice(1, 1);
      }
    }
  }

  getGridData() {
    this.layoutService.showLoader = true;
    this.service.GetUsersInstitutionDetails(this.userData).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      const roleId = this.userData.roleName.roleId
      res = res.filter(inst => roleId > 2 ? inst.institution.institution.status : true);
      if (this.userData.roleName.roleId == 4 || this.userData.roleName.roleId == 3) {
        this.noWebKessInsPresent = res.every(el => {
          return (el.institution.institution.activateWebKess == null || el.institution.institution.activateWebKess == "") && (el.institution.institution.additionalChanges == null || el.institution.institution.additionalChanges == "")
        });
        if (this.noWebKessInsPresent) {
          this.fields.splice(this.fields.findIndex(el => el.title == "webKess"), 1);
        }
      }
      if(res.length > 0) {
        res.forEach(dataItem =>{
          dataItem.institutionType = (dataItem.institution.institution.institutionType)  ? this.layoutService.translateText('INSTITUTION_MANAGEMENT.TYPE.'+ dataItem.institution.institution.institutionType) : '';
        });

        if(this.userData.roleName.roleId == 2) {
          if(this.userData.country=="3" || this.userData.country=="219" || this.userData.country=="15") {
            res.forEach(dataItem =>{
              dataItem.webKessValue = (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.additionalChanges)  ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.layoutService.translateText('DASHBOARD.OBSERVATIONS')+'-'+this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.layoutService.translateText('DASHBOARD.OBSERVATIONS') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
              // dataItem.webKessValue = (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.data.translatetext('Observations')+'-'+this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.data.translatetext('Observations') :  (dataItem.institution.institution.additionalChanges) ? (JSON.parse(dataItem.institution.institution.additionalChanges).Status.toLowerCase() == 'pending') ? this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
            })
          }
        } else if(this.userData.roleName.roleId == 4 || this.userData.roleName.roleId == 3) {
          if(!this.noWebKessInsPresent) {
            res.forEach(dataItem =>{
              dataItem.webKessValue = (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.additionalChanges)  ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.layoutService.translateText('DASHBOARD.OBSERVATIONS')+'-'+this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.layoutService.translateText('DASHBOARD.OBSERVATIONS') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
              // dataItem.webKessValue = (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.data.translatetext('Observations')+'-'+this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.data.translatetext('Observations') :  (dataItem.institution.institution.additionalChanges) ? (JSON.parse(dataItem.institution.institution.additionalChanges).Status.toLowerCase() == 'pending') ? this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
            })
          }
        } else {
          res.forEach(dataItem =>{
              dataItem.webKessValue = (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.additionalChanges)  ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.layoutService.translateText('DASHBOARD.OBSERVATIONS')+'-'+this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.layoutService.translateText('DASHBOARD.OBSERVATIONS') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
              // dataItem.webKessValue = (dataItem.institution.institution.countryID==3 || dataItem.institution.institution.countryID==219 || dataItem.institution.institution.countryID==15 ) ? (dataItem.institution.institution.institutionName!=="" && dataItem.institution.institution.institutionName!==null) ? (dataItem.institution.institution.activateWebKess == true) ? (dataItem.institution.institution.activateConsumption && dataItem.institution.institution.activateObservation) ? this.data.translatetext('Observations')+'-'+this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (dataItem.institution.institution.activateConsumption) ? this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.data.translatetext('Observations') :  (dataItem.institution.institution.additionalChanges) ? (JSON.parse(dataItem.institution.institution.additionalChanges).Status.toLowerCase() == 'pending') ? this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.data.translatetext('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;
          })
        }
      }

      const that = this;
      this.gridData = res.map(item => this.manageGrid(item, that));
    });
  }

  openModal(template: TemplateRef<any>, dataItem) {
    this.addToGroup.institutionID = dataItem.institution.institution.institutionID
    this.groupDataItem = dataItem;
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' })
    );
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  openUnGroupModal(ungroupmodal: TemplateRef<any>, dataItem) {
    this.removeFromGroup.institutionID = dataItem.institution.institution.institutionID
    this.removeFromGroup.groupID = 0;    
    this.groupDataItem = dataItem;
    this.modalRef = this.modalService.show(ungroupmodal, Object.assign({}, { class: 'w-420' })
    )
  }


  selectGroup(id: number, name: string) {
    this.addToGroup.groupID = id;
    this.addToGroup.groupName = name;
  }
  openstack(stackmodal: TemplateRef<any>) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(stackmodal,
      Object.assign({}, { class: 'w-420' })
    );
  }

  addInstitution(): void {
    //this.router.navigate(['institution/add']);
    this.onChildData('institution/add');
  }
  updateGroupId() {
    this.service.AddInstitutionToGroup(this.addToGroup).subscribe((res) => {
      this.groupDataItem.institution.institution.groupID = this.addToGroup.groupID;
      this.groupDataItem.groupName = this.addToGroup.groupName;
      this.addToGroup = {} as InstitutionData;
      this.modalRef.hide()
    })
  }
  removeGroupId() {
    this.service.AddInstitutionToGroup(this.removeFromGroup).subscribe((res) => {
      this.groupDataItem.institution.institution.groupID = 0;
      this.groupDataItem.groupName = '';
      this.removeFromGroup = {} as InstitutionData;
      this.modalRef.hide()
    })
  }

  trialInstitution(): void {
    this.onChildData('institution/trial');
  }
  onChildData(emitter){
    this.router.navigate([emitter]);
  }
  renameKey(object, key, newKey)  {
    const clonedObj = this.clone(object);
    const targetKey = clonedObj[key];
    delete clonedObj[key];
    clonedObj[newKey] = targetKey;
    return clonedObj;
  };

  clone(obj) {
    return  Object.assign({}, obj);
  }

  read_prop(obj, prop) {
    if(obj && prop) {
      return obj[prop];
    }
   }

   excelSave(component): void {
    const options = component.workbookOptions();
    const rows = options.sheets[0].rows;
    options.sheets[0].autoSizeRows = true;
    const columns = options.sheets[0].columns;

    columns.forEach((column) => {
      column.width = 250;
      column.autoWidth = false;
    });

    rows.forEach((row) => {
        row.cells.forEach((cell) => {
          cell.wrap = true;
        });
    });
    setTimeout(() => {
      component.save(options);
      this.layoutService.showLoader = false;
    },500)

}

  exportWebKess() {
    if (this.errFromExport){
      this.layoutService.showError(this.layoutService.translateText('Error while exporting'));
    } else if(this.emptyArrayExport) {
      this.layoutService.showError(this.layoutService.translateText('No records found'));
    } else {
      this.layoutService.showLoader = true;
      this.excelSave(this.excelexport);
    }
  }

  getFileName() {
    const currentDate = new Date();
    const format = 'xlsx';
    const month = (currentDate.getMonth() + 1 > 9) ? currentDate.getMonth() + 1 : ('0' + (currentDate.getMonth() + 1));
    const date = (currentDate.getDate() > 9) ? currentDate.getDate() : '0' + currentDate.getDate();
    return `${currentDate.getFullYear()}.${month}.${date}_${this.layoutService.translateText('Institutions')+'_Observe_MHS'}.${format}`;
  }

  searchTextChange() {
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  showGroupButton(dataItem) {

    if (this.userData.roleName.roleId == 3 || this.userData.roleName.roleId == 4) {
      return false;
    }
    if (dataItem.institution.institution.isGroup) {
      return false;
    }
    if(dataItem.institution.institution.groupID == 0){
      return true;
    }
  }

  showUnGroupButton(dataItem) {

    if (this.userData.roleName.roleId == 3 || this.userData.roleName.roleId == 4) {
      return false;
    }
    if (dataItem.institution.institution.isGroup) {
      return false;
    }
    if(dataItem.institution.institution.groupID != 0){
      return true;
    }
  }

  manageGrid(item, that){

    const countryName = item.institution.countryName;
    item.countryName = this.layoutService.translateText(countryName);

    item.groupName = (item.institution.groupName) ? item.institution.groupName : '';
    item.institutionName = (item.institution.institution.institutionName) ? item.institution.institution.institutionName : '';
    item.bedSize = (item.institution.institution.bedSize) ? item.institution.institution.bedSize : '';


    let canShowActionItem = true;;
    if (this.userData.roleName.roleId == 3 || this.userData.roleName.roleId == 4) {
      canShowActionItem = false;
    }
    if (item.institution.groupName != '') {
      canShowActionItem = false;
    }
    if (item.institution.institution.isGroup) {
      canShowActionItem = false;
    }
    let actionItems = JSON.parse(JSON.stringify(this.actionItems));
    if (!canShowActionItem) {
      let removableIndex = actionItems.findIndex(el => el.name == "INSTITUTION_MANAGEMENT.ADD_TO_GROUP");
      actionItems.splice(removableIndex, 1);
    }
    let filtered = [];
    for (var arr in this.actionItems) {
      for (var filter in actionItems) {
        if (this.actionItems[arr].name == actionItems[filter].name) {
          filtered.push(this.actionItems[arr]);
        }
      }
    }
    item.actionItems = filtered;
    if (!item.institution.institution.isGroup) {
      if (item.institution.institution.usedLicenseCount === null) {
        item.institution.institution.usedLicenseCount = 0;
      }
    }

    item.userAccounts = (item.institution.institution.isGroup) ? "" : (item.institution.institution.usedLicenseCount + "/" +item.institution.institution.userLicense);
    item.institutionType = item.institution.institution.institutionType ? 'INSTITUTION_MANAGEMENT.TYPES.' + item.institution.institution.institutionType : '';
    item.activateWebKess = (item.institution.institution.countryID==3 || item.institution.institution.countryID==219 || item.institution.institution.countryID==15 ) ? (item.institution.institution.institutionName!=="" && item.institution.institution.institutionName!==null) ? (item.institution.institution.additionalChanges)  ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.REQUESTED') : (item.institution.institution.activateWebKess == true) ? (item.institution.institution.activateConsumption && item.institution.institution.activateObservation) ? this.layoutService.translateText('DASHBOARD.OBSERVATIONS')+'-'+this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : (item.institution.institution.activateConsumption) ? this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.CONSUMPTIONS') : this.layoutService.translateText('DASHBOARD.OBSERVATIONS') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_CONFIGURED') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') : this.layoutService.translateText('WEBKESS_INTEGRATION.TEMPLATE.NOT_APPLICABLE') ;

    return item;
  }

}
